import type { UserAttendeeView } from '#shared/types/user-attendees'

export interface GodmodeFormResponse {
  question_id: string
  answer: string | number | boolean | null | string[]
}

export interface GodmodeParticipantData {
  first_name: string
  last_name: string
  rijksregisternummer: string
  date_of_birth: string
  gender: string
  medical_info: string
  allergies: string
  emergency_contact_name: string
  emergency_contact_phone: string
  form_responses: GodmodeFormResponse[]
}

export interface GodmodeSlot {
  id: string
  type: 'week' | 'day'
  selectedDays: string[]
  savedAttendee: UserAttendeeView | null
  newAttendeeSelected: boolean
  isExpanded: boolean
  noRrn: boolean
  participant: GodmodeParticipantData
}

export const useGodmodeSlots = () => {
  const slots = useState<GodmodeSlot[]>('gm-slots', () => [])

  const createEmptyParticipant = (): GodmodeParticipantData => ({
    first_name: '',
    last_name: '',
    rijksregisternummer: '',
    date_of_birth: '',
    gender: '',
    medical_info: '',
    allergies: '',
    emergency_contact_name: '',
    emergency_contact_phone: '',
    form_responses: [],
  })

  const createSlot = (expanded = true): GodmodeSlot => ({
    id: `gm-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type: 'week',
    selectedDays: [],
    savedAttendee: null,
    newAttendeeSelected: false,
    isExpanded: expanded,
    noRrn: false,
    participant: createEmptyParticipant(),
  })

  const resetSlots = () => {
    slots.value = []
  }

  return { slots, createEmptyParticipant, createSlot, resetSlots }
}
